import { ItunesTrack } from '../../classes/itunes'
import { Track } from '../../classes/track'

const SPECIAL_CHARS_REGEX = /[\!\@\#\$\%\^\&\*\(\)\{\}\[\]\:\;\'\"\<\>\,\.\/\\\|\-\_\+\=]/g
const BETWEEN_PARENTHESIS_REGEX = /\s*\(.*?\)\s*/g

function getSplit(s: string): string[] {
  const clean: string = s.replace(SPECIAL_CHARS_REGEX, ' ') // Remove non a-z and 0-9
  const split: string[] = clean.split(' ')
    .filter(x => !!x)
    .filter(x => x.length > 1)

  return split
}

export function trackListContainsItunesTrack(tracks: Track[], itunesTrack: ItunesTrack): Track | null {
  for (const track of tracks) {
    if (!track.title || !track.artist) continue

    let itunesTitle: string = itunesTrack.title.toLowerCase()
    const itunesArtist: string = itunesTrack.artistName.toLowerCase()

    const trackTitle: string = track.title.toLowerCase()
    const trackArtist: string = track.artist.toLowerCase()

    if (itunesTitle.includes('(feat')) {
      itunesTitle = itunesTitle.replace(BETWEEN_PARENTHESIS_REGEX, '')
    }

    if (
      (itunesTitle.includes('mix') && !trackTitle.includes('mix')) ||
      (trackTitle.includes('mix') && !itunesTitle.includes('mix'))
    ) continue

    if (
      (itunesTitle.includes('radio edit') && !trackTitle.includes('radio edit')) ||
      (trackTitle.includes('radio edit') && !itunesTitle.includes('radio edit'))
    ) continue

    const titleSplit = getSplit(itunesTitle)
    const artistSplit = getSplit(itunesArtist)

    const titleMatch: boolean = titleSplit.every(s => trackTitle.includes(s))
    const artistMatch: boolean = artistSplit.every(s => trackArtist.includes(s))

    if (titleMatch && artistMatch) return track // Stop early, no need to go through the rest of the tracks, already found a match
  }

  return null
}
